import React from 'react';

const CotizarContext = React.createContext({

    genericOptionsFormasDePago: null,
    autosMarcas: null,
    localidades: null,
    destinos: null,
    coberturasInfo: null,
    coberturasAdicionalesOrder: null,
    companiesDict: null,
    companiesIdDict: null,
    provinciasList: null,
    coberturasProductsInfo: null,
    isReady: false,

});

export default CotizarContext;